/* AFS B2B — comparison page (PB-09). Compare IDs live in localStorage
   (via b2b-lists.js); product facts load from canonical /products/{handle}.js so
   the page never invents data. Renders sticky attribute labels + product columns,
   highlight-differences toggle, and per-product cart/quote actions. */
(function () {
  'use strict';

  var root = document.getElementById('CompareApp');
  if (!root) return;

  function getCompare() {
    try { return JSON.parse(localStorage.getItem('afs:compare')) || []; } catch (e) { return []; }
  }

  var ATTRS = [
    { key: 'sku', label: 'SKU', group: 'Commerce' },
    { key: 'mpn', label: 'MPN', group: 'Commerce' },
    { key: 'vendor', label: 'Brand', group: 'Commerce' },
    { key: 'price', label: 'Price', group: 'Commerce' },
    { key: 'uom', label: 'Unit of measure', group: 'Pack' },
    { key: 'inner_pack', label: 'Inner pack', group: 'Pack' },
    { key: 'case_qty', label: 'Case quantity', group: 'Pack' },
    { key: 'availability', label: 'Availability', group: 'Availability' },
    { key: 'lead_time', label: 'Lead time', group: 'Availability' },
    { key: 'compatibility', label: 'Compatibility', group: 'Compatibility' },
    { key: 'country', label: 'Country of origin', group: 'Specifications' },
    { key: 'returnable', label: 'Returnable', group: 'Returns' }
  ];

  function mf(product, ns, key) {
    try { return (product.metafields && product.metafields[ns] && product.metafields[ns][key]) || ''; }
    catch (e) { return ''; }
  }

  function extract(product) {
    var v = product.variants && product.variants[0] ? product.variants[0] : {};
    return {
      title: product.title,
      url: product.url || ('/products/' + product.handle),
      image: product.featured_image || (product.media && product.media[0] && product.media[0].preview_image && product.media[0].preview_image.src),
      variantId: v.id,
      available: product.available,
      sku: mf(product, 'b2b', 'supplier_sku') || v.sku || '',
      mpn: mf(product, 'b2b', 'mpn'),
      vendor: product.vendor,
      price: v.price != null ? formatMoney(v.price) : '',
      uom: mf(product, 'b2b', 'uom'),
      inner_pack: mf(product, 'b2b', 'inner_pack'),
      case_qty: mf(product, 'b2b', 'case_qty'),
      availability: mf(product, 'b2b', 'availability_state') || (product.available ? 'In stock' : 'Unavailable'),
      lead_time: mf(product, 'b2b', 'lead_time'),
      compatibility: mf(product, 'b2b', 'compatibility'),
      country: mf(product, 'b2b', 'country_of_origin'),
      returnable: mf(product, 'b2b', 'returnable') === true ? 'Yes' : (mf(product, 'b2b', 'returnable') === false ? 'No' : '')
    };
  }

  function formatMoney(cents) {
    var fmt = (window.AFSConfig && window.AFSConfig.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)).replace(/<[^>]+>/g, '');
  }

  function render(products) {
    if (!products.length) {
      root.innerHTML = '<div class="b2b-empty"><h2>' + root.dataset.emptyTitle + '</h2><p>' + root.dataset.emptyHelp + '</p></div>';
      return;
    }
    var highlight = root.querySelector('#HighlightDiff') && root.querySelector('#HighlightDiff').checked;
    var html = '<div class="table-wrap"><table class="data-table compare-table"><thead><tr><th scope="col">' + (root.dataset.attrLabel || 'Attribute') + '</th>';
    products.forEach(function (p) {
      html += '<th scope="col"><div style="display:flex;flex-direction:column;gap:8px;">' +
        (p.image ? '<img src="' + p.image + '" alt="" style="width:100%;max-width:120px;aspect-ratio:1;object-fit:contain;">' : '') +
        '<a href="' + p.url + '" style="font-weight:600;">' + escapeHtml(p.title) + '</a>' +
        '<button type="button" class="text-link" data-compare-remove="' + escapeHtml(p.handle) + '">Remove</button>' +
        '</div></th>';
    });
    html += '</tr></thead><tbody>';
    var lastGroup = '';
    ATTRS.forEach(function (attr) {
      if (attr.group !== lastGroup) {
        html += '<tr class="compare-table__group"><th colspan="' + (products.length + 1) + '">' + attr.group + '</th></tr>';
        lastGroup = attr.group;
      }
      var values = products.map(function (p) { return p[attr.key] || '—'; });
      var allSame = values.every(function (v) { return v === values[0]; });
      var rowStyle = (highlight && !allSame) ? ' class="is-diff"' : '';
      html += '<tr' + rowStyle + '><th scope="row">' + attr.label + '</th>';
      values.forEach(function (v) { html += '<td>' + escapeHtml(String(v)) + '</td>'; });
      html += '</tr>';
    });
    // Action row
    html += '<tr><th scope="row">Actions</th>';
    products.forEach(function (p) {
      html += '<td><div class="stack-sm">' +
        (p.available && p.variantId ? '<button type="button" class="btn btn--primary btn--sm" data-compare-add="' + p.variantId + '">Add to cart</button>' : '') +
        '<a href="' + p.url + '" class="btn btn--quiet btn--sm">View product</a></div></td>';
    });
    html += '</tr></tbody></table></div>';
    root.querySelector('#CompareTable').innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function load() {
    var items = getCompare();
    if (!items.length) { render([]); return; }
    Promise.all(items.map(function (i) {
      return fetch('/products/' + i.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? Object.assign(extract(p), { handle: i.handle }) : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      render(products.filter(Boolean));
    });
  }

  root.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-compare-remove]');
    if (remove && window.AFSB2B) {
      window.AFSB2B.Compare.remove(remove.getAttribute('data-compare-remove'));
      load();
    }
    var add = e.target.closest('[data-compare-add]');
    if (add && window.AFSCart) {
      window.AFSCart.add([{ id: parseInt(add.getAttribute('data-compare-add'), 10), quantity: 1 }])
        .then(function () { window.AFSToast('Added to cart', { tone: 'success', linkHref: window.AFSConfig.routes.cart, linkText: 'View cart' }); });
    }
  });

  var toggle = root.querySelector('#HighlightDiff');
  if (toggle) toggle.addEventListener('change', load);
  document.addEventListener('afs:lists-updated', load);
  load();
})();
